import { HookAtomRender } from '@/app/editor/iframe/atom/atom-service/render/BaseAtomRender';

/**
 * AtomRender for ElementRender
 */
export class ElementRender extends HookAtomRender {
  /**
   * [Hook]
   * renderTemplate
   */
  async renderTemplate(): Promise<void> {
    const htmlExited = this.atom.$gryffEditor.find(this.atom.getIdNode()).html();
    if (!htmlExited) {
      // Nếu không tồn tại thì render
      const templateTmp = this.getAtomModel().html;
      this.get$el().html(templateTmp);
    }
  }

  /**
   * [Filter] [Init]
   * Parse chuỗi có cấu trúc Liquid thành HTML dạng Promise
   * @param templateTmp chuỗi template có chứa code liquid cần format
   * @returns trả về một chuỗi HTML
   */
  async renderLiquid(templateTmp: string): Promise<string> {
    return templateTmp;
  }
}
